import { doPost } from "../api/baseAPI";
import { GROLOG_URL } from "../constant/apiConstant"

export const POSTGetInitiateServices = async (token, api_contract, body) => {
  const url = `${GROLOG_URL}/${api_contract}/initiate`;
  let result = { 
    success: false, 
    initiate: undefined, 
    errorCode: undefined, 
    message: undefined 
  }

  try {
    const response = await doPost(url, token, body);
    if (response) {
      result.success = true;
      result.initiate = response?.data?.payload?.data;
      result.message = response?.data?.payload?.status?.message;
      delete result.errorCode;
    }
  } catch (error) {
    console.log(error);
    result.success = false;
    // result.errorCode = error?.response?.data?.payload?.status?.code;
    delete result.initiate;
  }
return result
}